import { UPLOAD_EXCEL } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const uploadExcel = (payload) => {
  return apiInstance.post(UPLOAD_EXCEL, payload);
};
